import { tracker } from 'app-components/utils/core';

export const sendApplicableExperimentEvents = (allRawLDFlags: Record<string, unknown>) => {
  Object.keys(allRawLDFlags).forEach((flag) => {
    if (flag.endsWith('.experiment') && allRawLDFlags[flag] !== 'Reqs Not Met') {
      tracker.track('$experiment_started', {
        'Experiment name': flag,
        'Variant name': allRawLDFlags[flag],
      });
    }
  });
};
